// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"fc4f2bab","455":"dc231fcd","977":"0ac6ff83"}[chunkId] + ".chunk.js";
};